<template>
  <a
    :href="block.data.url"
    :class="['file-document-access', $route.name === 'map' ? 'file-document-access-map' : '']"
    @click.prevent="$files.getFile(block.data.url)"
  >
    <span class="file-document-access-icon">
      <i :class="iconClass"></i>
    </span>
    <span class="file-document-access-info">
      <span class="file-document-access-info-name">
        {{ block.data.name }}
      </span>
      <span class="file-document-access-info-action">
        <i class="far fa-arrow-to-bottom font-size-small"></i>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  name: 'MoleculeContentNodeBlockDocument',

  props: {
    block: Object
  },

  data () {
    return {
      iconClasses: {
        doc: 'far fa-file-word text-color-content-document-word',
        docx: 'far fa-file-word text-color-content-document-word',
        gif: 'far fa-file-image text-color-content-document',
        jpg: 'far fa-file-image text-color-content-document',
        jpeg: 'far fa-file-image text-color-content-document',
        pdf: 'far fa-file-pdf text-color-content-document-pdf',
        png: 'far fa-file-image text-color-content-document',
        ppt: 'far fa-file-powerpoint text-color-content-document-ppt',
        pptx: 'far fa-file-powerpoint text-color-content-document-ppt',
        txt: 'far fa-file-alt text-color-content-document',
        xls: 'far fa-file-excel text-color-content-document-excel',
        xlsx: 'far fa-file-excel text-color-content-document-excel',
        zip: 'far fa-file-archive text-color-content-document'
      }
    }
  },

  computed: {
    iconClass () {
      return this.iconClasses[this.block.data.name.split('.').pop()]
    }
  }
}
</script>
